import { render } from "./index.vue?vue&type=template&id=7ee838f6"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/pages/tags/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7ee838f6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7ee838f6', __exports__)) {
    console.log('reload')
    api.reload('7ee838f6', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=7ee838f6", () => {
    console.log('re-render')
    api.rerender('7ee838f6', render)
  })

}


export default __exports__